import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As of July 23rd, 2026, all new release documentation will be published alongside their respective release packages through our `}<a parentName="p" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`support portal`}</a>{` `}</p>
    <p>{`In addition to new releases, Cúram 8.2.2.0 (released July 3rd, 2026) and Cúram Action View 1.0.0 (released June 25th, 2026) documentation will also be available via our support portal for download.`}</p>
    <h3>{`For any other documentation referenced on this page, please contact `}<a parentName="h3" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`Merative Support`}</a></h3>
    <p>{`Citizen Engagement v8.3.3 is now available for customers on Cúram v8.2.2, v8.1.3, v8.0.3, v8.0.2, v7.0.11, and v7.0.10..
This release includes accessibility fixes in the WebApp and the Design System.`}</p>
    <p>{`For more information on this release, see the:`}</p>
    <ul>
      <li parentName="ul">{`8.3.3 Universal Access Web Application guide `}</li>
      <li parentName="ul">{`8.3.3 Design System guide`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      